module.exports = __webpack_public_path__ + "static/media/banner-5.50820664.jpeg";